import {ApplicationConfig, importProvidersFrom, isDevMode} from '@angular/core';
import {provideRouter, withInMemoryScrolling, withViewTransitions} from '@angular/router';
import { routes } from '../routes/app.routes';
import {
  provideClientHydration,
  withHttpTransferCacheOptions,
  withI18nSupport
} from '@angular/platform-browser';
import localeFr from '@angular/common/locales/fr';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi
} from "@angular/common/http";
import {SwiperModule} from "swiper/angular";
import {NgxSmartModalModule} from "ngx-smart-modal";
import { provideServiceWorker } from '@angular/service-worker';
import {
  DatePipe,
  IMAGE_CONFIG,
  IMAGE_LOADER,
  ImageLoaderConfig,
  PRECONNECT_CHECK_BLOCKLIST,
  registerLocaleData
} from "@angular/common";
import {environment} from "../../environments/environment";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {NgcCookieConsentConfig, provideNgcCookieConsent} from "ngx-cookieconsent";
import {DpDatePickerModule} from "ng2-date-picker";
registerLocaleData(localeFr, 'fr');


const cookieConfig:NgcCookieConsentConfig = {};

const imports = [
  SwiperModule,
  DatePipe,
  BrowserAnimationsModule,
  InfiniteScrollModule,
  DpDatePickerModule,
  NgxSmartModalModule.forRoot()
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withViewTransitions(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'disabled'
      }),
    ),
    importProvidersFrom(imports),
    provideNgcCookieConsent(cookieConfig),
    provideClientHydration(
      withHttpTransferCacheOptions({includePostRequests: true}),
      withI18nSupport()
    ),
    {provide: PRECONNECT_CHECK_BLOCKLIST, useValue: environment.wpApiUrl},
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        const fit =  config.loaderParams && config.loaderParams['fit'] ? config.loaderParams['fit'] : 'cover';
        return `https://wsrv.nl/?url=${config.src}&w=${config.width}&output=webp&fit=${fit}`;
      },
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        breakpoints: [460, 645, 860, 1290, 1920, 2400]
      }
    },
    provideHttpClient(withFetch(),withInterceptorsFromDi()),
    provideServiceWorker('ngsw-worker.js', {
        enabled: true,
        registrationStrategy: 'registerWhenStable:30000',
    })
]
};
